import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSavedFilter } from '../queryKeys';

import { deleteSavedFilter } from './deleteSavedFilter';
import { type DeleteSavedFilterMutationOptions } from './types';

/**
 * React Query based custom hook for deleting saved filters.
 *
 * Invalidates the saved-filter list for the deleted filter type on settle.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/User/operation/delete_saved_filter_user_saved_filters__saved_filter_id__delete
 */
export const useMutationDeleteSavedFilter = (
  options?: DeleteSavedFilterMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ savedFilterId }) => deleteSavedFilter(savedFilterId),
    onSettled(_data, _error, { type }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysSavedFilter.getAll(type),
      });
    },
    ...options,
  });
};
